import React from "react";
import Header from "@/components/Header";
import ScoutDashboard from "@/pages/ScoutDashboard";
import OperatorDashboard from "@/pages/OperatorDashboard";
import { useApp } from "@/lib/AppContext";

export default function Portal() {
  const { user } = useApp();
  return (
    <div className="min-h-screen">
      <Header />
      {user?.role === "operator" ? <OperatorDashboard /> : <ScoutDashboard />}
    </div>
  );
}
